export default function MissionVision() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-blue-100 to-teal-100 rounded-full blur-3xl opacity-30 -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-purple-100 to-blue-100 rounded-full blur-3xl opacity-30 translate-y-1/2 -translate-x-1/2"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-600 text-sm font-semibold uppercase tracking-wider rounded-full mb-4">
            Our Purpose
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Mission &amp; Vision
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            Driving educational transformation through STEM excellence and innovation
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Mission Card */}
          <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-3xl p-10 border-2 border-blue-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-600 to-blue-400 flex items-center justify-center mb-5 shadow-lg">
              <i className="ri-compass-3-line text-2xl text-white"></i>
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-4">Our Mission</h3>
            
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              To transform schools into STEM innovation hubs by providing comprehensive, curriculum-aligned programs that prepare students for tech-driven careers while ensuring academic excellence and industry readiness.
            </p>

            <div className="space-y-3">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">We are committed to:</h4>
              {[
                'Delivering NEP 2020 compliant STEM education programs',
                'Bridging the gap between academic learning and industry requirements',
                'Empowering teachers with continuous professional development',
                'Creating hands-on learning experiences through state-of-the-art labs',
                'Fostering innovation, creativity, and problem-solving skills'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <i className="ri-arrow-right-circle-fill text-blue-600 text-xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Vision Card */}
          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-3xl p-10 border-2 border-purple-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-600 to-purple-400 flex items-center justify-center mb-5 shadow-lg">
              <i className="ri-eye-line text-2xl text-white"></i>
            </div>
            
            <h3 className="text-xl font-bold text-gray-900 mb-4">Our Vision</h3>
            
            <p className="text-sm text-gray-700 leading-relaxed mb-6">
              To be India's leading STEM education partner, recognized for creating future-ready students who excel in technology, innovation, and critical thinking, while making quality STEM education accessible to every school across the nation.
            </p>

            <div className="space-y-3">
              <h4 className="text-sm font-semibold text-gray-900 mb-3">We envision a future where:</h4>
              {[
                'Every student has access to world-class STEM education',
                'Schools are equipped with cutting-edge AI and robotics labs',
                'Teachers are empowered as STEM education leaders',
                'Students seamlessly transition from classroom to industry',
                'India becomes a global hub for STEM innovation and talent'
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <i className="ri-star-fill text-purple-600 text-xl flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div className="mt-16 bg-gradient-to-r from-gray-50 to-blue-50 rounded-3xl p-10">
          <h3 className="text-xl font-bold text-gray-900 text-center mb-8">Our Core Values</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-lightbulb-flash-line',
                title: 'Innovation',
                description: 'Continuously evolving our programs to stay ahead of technological advancements'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Excellence',
                description: 'Maintaining the highest standards in curriculum, infrastructure, and support'
              },
              {
                icon: 'ri-team-line',
                title: 'Partnership',
                description: 'Building long-term relationships with schools as true academic partners'
              },
              {
                icon: 'ri-heart-line',
                title: 'Impact',
                description: 'Measuring success by the real-world outcomes of our students'
              }
            ].map((value, idx) => (
              <div key={idx} className="text-center">
                <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mx-auto mb-4 shadow-md">
                  <i className={`${value.icon} text-2xl text-blue-600`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{value.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
